import { createIcon } from '@chakra-ui/icon';
export var CaretDownIcon = createIcon({
  displayName: 'CaretDownIcon',
  viewBox: '0 0 14 24',
  d: 'M7.707 15.293a1 1 0 01-1.414 0l-4.586-4.586C1.077 10.077 1.523 9 2.414 9h9.172c.89 0 1.337 1.077.707 1.707l-4.586 4.586z'
});
//# sourceMappingURL=CaretDown.js.map